module.exports = __webpack_public_path__ + "img/p10.f4a04379.png";